import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCode24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCode24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.385 7.709a.75.75 0 1 0-1.4-.538l-3.428 8.93a.75.75 0 0 0 1.4.537zm-6.323 9.296a.75.75 0 0 1-1.06 0L2.53 12.534l-.53-.53.53-.53 4.471-4.472a.75.75 0 0 1 1.06 1.061l-3.94 3.94 3.94 3.941a.75.75 0 0 1 0 1.06m7.88-10.003a.75.75 0 0 1 1.061 0l4.471 4.471.53.53-.53.53-4.47 4.472a.75.75 0 0 1-1.061-1.061l3.94-3.94-3.94-3.94a.75.75 0 0 1 0-1.062"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCode24);
